<template>
    <v-form>
        <div class="az-form-content dados-gerais">
          <div v-if="dadosGerais.situacao === 'SUSPENSA'"
               class="alert-suspensa mb-4 p-3"
               style="background-color: #fff8e1;
                border-left: 4px solid #ffa000;
                 border-radius: 4px;
                 padding: 10px;
                  color: #795548;">
            <strong>Compra Direta Suspensa! </strong>
            <a href="#" @click.prevent="abrirModalSuspensao"
               style="color: inherit; margin-left: 4px; text-decoration: underline;">Ver Motivo
            </a>
          </div>

          <v-container fluid grid-list-xl white>
                <painel-processo-visualizacao v-model="dadosGerais"/>

                <painel-compra-direta-edicao v-if="!compraSuspensa"
                                             v-model="dadosGerais"
                                             :intervaloDuracaoLancesLei8666="intervaloDuracaoLancesLei8666"
                                             :intervaloDuracaoLancesLei14133="intervaloDuracaoLancesLei14133"
                                             :intervaloDuracaoLancesLei13303="intervaloDuracaoLancesLei13303"
                                             :tempoRandomicoLance="tempoRandomicoLance"
                                             :lei14133UsaTempoRandomicoLance="lei14133UsaTempoRandomicoLance"
                                             :lei13303UsaTempoRandomicoLance="lei13303UsaTempoRandomicoLance"
                                             :ehCompraPropostaManualEhAtiva="ehCompraPropostaManualEhAtiva"/>

                <painel-compra-direta-visualizacao v-else
                                                   v-model="dadosGerais"
                                                   :modoDeCriacaoManual="modoDeCriacaoManual"
                                                   :exibirFimEnvioPropostasELances="exibirFimPropostasELances"
                                                   :tempoRandomicoLance="tempoRandomicoLance"
                                                   :ehALei14_133="ehALei14_133"
                                                   :ehCompraPropostaManualEhAtiva="ehCompraPropostaManualEhAtiva"/>

                <painel-anexo-edicao v-if="!compraSuspensa"
                                     v-model="dadosGerais.anexos"
                                     :documentos="documentos"
                                     :paginas="null"
                                     :paginacao="null"
                                     :situacaoCompraDireta="dadosGerais.situacao"
                                     @excluirAnexo="tratarEventoExibirDialogoDeExclusao"
                                     @adicionarAnexo="tratarEventoAdicionarAnexo"
                                     @atualizarTipoAnexo="tratarEventoAtualizarTipoAnexo"
                                     @downloadAnexo="tratarEventDownloadAnexo"
                                     @atualizarSituacaoAnexo="exibirModalAtualizarSituacaoAnexo"/>

                <painel-anexo-visualizacao v-else
                                           v-model="dadosGerais.anexos"
                                           :documentos="documentos"
                                           :situacaoCompraDireta="dadosGerais.situacao"
                                           :paginas="null"
                                           :paginacao="null"
                                           @downloadAnexo="tratarEventDownloadAnexo"
                                           @atualizarSituacaoAnexo="exibirModalAtualizarSituacaoAnexo"/>
            </v-container>
        </div>

        <div class="az-actions-form ajuste-acoes">
            <botao-voltar @voltar="tratarEventoVoltar"/>
            <botao-salvar v-if="!compraSuspensa" @salvar="tratarEventoSalvar"/>
            <botao-salvar-avancar v-if="!compraSuspensa" @salvarEAvancar="tratarEventoSalvarEAvancar"/>
            <botao-avancar v-if="compraSuspensa" @avancar="tratarEventoAvancar"/>
        </div>

        <mensagem-confirmacao :exibirMensagem="mostrarDialogoExclusao"
                              @confirmado="tratarEventoDeRemoverAnexo"
                              @recusado="mostrarDialogoExclusao = false"/>

        <mensagem-confirmacao class="DialogoConfirmaSituacao"
                              :exibirMensagem="mostrarDialogoAtivoInativo"
                              :titulo="titulo"
                              :textoSecundario="mensagem"
                              @confirmado="tratarEventoDeAtualizarSituacaoAnexo"
                              @recusado="fecharModalAtualizarSituacaoAnexo"/>

      <az-confirm
          v-if="(possuiAnexosNaoSalvos() || possuiDadosNaoSalvos()) && mostrarDialogConfirmarSaida"
          @onConfirm="sairDaTela(nextFunction)"
          @onDecline="mostrarDialogConfirmarSaida = false"
      >
    <span v-if="possuiAnexosNaoSalvos() && !possuiDadosNaoSalvos()">
        Existem anexos que não foram salvos. Deseja sair sem salvar?
    </span>

        <span v-else>
        Existem dados que não foram salvos. Deseja sair sem salvar?
    </span>
      </az-confirm>

        <v-dialog v-if="dadosGerais.situacao !== 'EM_ELABORACAO'" v-model="mostrarModalSuspensao" persistent max-width="800px">
            <modal-suspender-compra-direta
                v-model="dadosGerais"
                :modo-visualizacao="false"
                :motivo-suspensao="dadosGerais.justificativaSuspensao"
                :anexo-suspensao="dadosGerais.anexoSuspensao"
                @fecharModalSuspensao="fecharModalSuspensao"
                @salvarSuspensao="tratarEventoSuspender"
                @downloadAnexo="tratarEventDownloadAnexo"/>
        </v-dialog>
    </v-form>
</template>

<script>
import {mapState} from 'vuex'
import moment from 'moment'
import {actionTypes, mutationTypes} from '@/core/constants'
import PainelCompraDiretaEdicao from '@/views/pages/commons/painel/painel-compra-direta/PainelCompraDiretaEdicao'
import PainelCompraDiretaVisualizacao from '@/views/pages/commons/painel/painel-compra-direta/PainelCompraDiretaVisualizacao'
import PainelProcessoVisualizacao from '@/views/pages/commons/painel/painel-processo/PainelProcessoVisualizacao'
import PainelAnexoEdicao from '@/views/pages/commons/painel/painel-anexo/PainelAnexoEdicao'
import PainelAnexoVisualizacao from '@/views/pages/commons/painel/painel-anexo/PainelAnexoVisualizacao'
import MensagemConfirmacao from '@/views/components/MensagemConfirmacao.vue'
import ModalSuspenderCompraDireta from '@/views/pages/comprador/execucao-compra-direta/acoes/ModalSuspenderCompraDireta'
import amparoLegalUtils from '@/views/mixins/amparoLegalUtils'
import exibirFimProposta from '@/views/mixins/exibirFimProposta'
import BotaoVoltar from '@/views/components/BotaoVoltar.vue'
import BotaoSalvar from '@/views/components/BotaoSalvar.vue'
import BotaoSalvarAvancar from '@/views/components/BotaoSalvarAvancar.vue'
import BotaoAvancar from '@/views/components/BotaoAvancar.vue'
import { calcularDiasUteisComHoras } from '@/core/utils/CalcularDiasUteisUtil'

export default {
    name: 'DadosGeraisEdicao',
    $_veeValidate: {
        validator: 'new'
    },
    mixins: [amparoLegalUtils, exibirFimProposta],
    components: {
        BotaoAvancar,
        BotaoSalvarAvancar,
        BotaoSalvar,
        BotaoVoltar,
        MensagemConfirmacao,
        PainelAnexoEdicao,
        PainelAnexoVisualizacao,
        PainelProcessoVisualizacao,
        PainelCompraDiretaEdicao,
        PainelCompraDiretaVisualizacao,
        ModalSuspenderCompraDireta
    },
    data() {
        return {
            dadosGerais: {
                anexos: [],
            },
            originalDadosGeraisSnapshot: null,
            compraDiretaId: null,
            documentos: [],
            mostrarDialogoExclusao: false,
            mostrarDialogConfirmarSaida: false,
            anexoId: null,
            rotasAvancar: [
                {
                    name: 'ItensLotesEdicao'
                },
                {
                    name: 'DocumentosEdicao'
                },
                {
                    name: 'AcompanhamentoVisualizacao'
                }
            ],
            mostrarDialogoAtivoInativo: false,
            titulo: '',
            mensagem: '',
            mostrarModalSuspensao: false
        }
    },
    computed: {
        ...mapState(['loki', 'parametros']),
        modoDeCriacaoManual() {
            return this.parametros.propriedadesCompraDiretas.modoCriacao === 'MANUAL'
        },
        tempoRandomicoLance() {
            return this.parametros.propriedadesCompraDiretas.tempoRandomicoLance
        },
        lei14133UsaTempoRandomicoLance() {
            return this.parametros.propriedadesCompraDiretas.lei14133UtilizarTempoRandomicoLance
        },
        lei13303UsaTempoRandomicoLance() {
            return this.parametros.propriedadesCompraDiretas.lei13303UtilizarTempoRandomicoLance
        },
        intervaloDuracaoLancesLei8666()
        {
            return {
                min: this.parametros.propriedadesCompraDiretas.tempoMinimo8666,
                max: this.parametros.propriedadesCompraDiretas.tempoMaximo8666
            }
        },
        intervaloDuracaoLancesLei14133()
        {
            return {
                min: this.parametros.propriedadesCompraDiretas.tempoMinimo14133,
                max: this.parametros.propriedadesCompraDiretas.tempoMaximo14133
            }
        },
        intervaloDuracaoLancesLei13303()
        {
            return {
                min: this.parametros.propriedadesCompraDiretas.tempoMinimo13303,
                max: this.parametros.propriedadesCompraDiretas.tempoMaximo13303
            }
        },
        compraSuspensa() {
            return this.dadosGerais.situacao === 'SUSPENSA'
        },
        exibirFimEnvioPropostasELances(){
            return this.exibirFimPropostasELances(this.dadosGerais.amparoLegal)
        },
        ehALei14_133(){
            return this.ehLei14_133(this.dadosGerais.amparoLegal)
        },
        ehCompraPropostaManualEhAtiva() {
            return this.propostaManualAtiva && this.amparoLegalEhLei14133Art75VIII
        },
        propostaManualAtiva() {
            return Boolean(this.parametros.propriedadesCompraDiretas.propostaManual)
        },
        amparoLegalEhLei14133Art75VIII() {
            const lei = this.dadosGerais?.amparoLegal?.lei || ''
            return typeof lei === 'string' && lei.includes('Lei 14.133/2021, Art. 75, VIII')
        },
    },
    async beforeRouteLeave(to, from, next) {
        const existemAlteracoesNaoSalvas = () => this.possuiAnexosNaoSalvos() || this.possuiDadosNaoSalvos()

        if (to && to.query && to.query.skipConfirmExit === 'true') {
            next()
            return
        }

        if (this.verificarRotaAvancar(to.name)) {
            try {
                if (!this.compraSuspensa) {
                    await this.validarTudo()
                }
                if (existemAlteracoesNaoSalvas()) {
                    this.logAlteracoesNaoSalvas()
                    this.confirmarSaidaDaTela(next)
                } else {
                    this.sairDaTela(next)
                }
            } catch (e) {
                this.mostrarNotificacaoErro(e.message)
                next(false)
            }
        } else {
            if (existemAlteracoesNaoSalvas()) {
                this.logAlteracoesNaoSalvas()
                this.confirmarSaidaDaTela(next)
            } else {
                next()
            }
        }
    },
    async mounted() {
        try {
            this.setCompraDiretaId()
            await this.buscarDadosGerais()
            await this.buscarDocumentos()
            await this.buscarOrgaosDisponiveis()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarDadosGerais() {
            await this.$store.dispatch(actionTypes.BUSCAR_DADOS_GERAIS, this.compraDiretaId)
            this.dadosGerais = this.$store.state.dadosGerais
            this.anexos = this.dadosGerais.anexos
            this.atualizarSnapshot()
        },
        async buscarDocumentos() {
            await this.$store.dispatch(actionTypes.BUSCAR_DOCUMENTOS, this.compraDiretaId)
            this.documentos = this.$store.state.documentos
        },
        async tratarEventoSalvar() {
            await this.salvarDadosGerais()
            this.mostrarNotificacaoSucessoDefault()
        },
        async tratarEventoSalvarEAvancar() {
            await this.salvarDadosGerais()
            this.mostrarNotificacaoSucessoDefault()
            this.redirecionarParaProximaPagina()
        },
        async tratarEventoDeAtualizarSituacaoAnexo(){
            const itemObj = {
                compraDiretaId: this.compraDiretaId,
                anexoId: this.anexoId,
                situacao: this.situacaoAnexo
            }
            await this.$store.dispatch(actionTypes.COMPRADOR.ATUALIZAR_SITUACAO_ANEXO_COMPRA_DIRETA, itemObj)
            this.fecharModalAtualizarSituacaoAnexo()
            this.mostrarNotificacaoSucesso('Situação alterada com sucesso.')
        },
        limparCamposIncongruentes(){
            if (this.ehCompraPropostaManualEhAtiva) {
                this.dadosGerais.dataHoraEncerramento = null
                this.dadosGerais.dataHoraInicioEnvioPropostas = null
                this.dadosGerais.dataHoraFimEnvioPropostas = null
            }
            if(this.exibirFimPropostasELances(this.dadosGerais.amparoLegal)){
                this.dadosGerais.dataHoraEncerramento = null
            }else{
                this.dadosGerais.dataHoraFimEnvioPropostas = null
            }
        },
        async salvarDadosGerais() {
            this.limparCamposIncongruentes()
            await this.validarTudo()
            this.dadosGerais.telefoneContato = this.removerMascaraTelefone(this.dadosGerais.telefoneContato)
            this.setMensagemLoading('Salvando a compra direta...')
            if (!this.modoDeCriacaoManual) {
                await this.$store.dispatch(actionTypes.SALVAR_DADOS_GERAIS, this.dadosGerais)
            }
            else {
                await this.$store.dispatch(actionTypes.COMPRADOR.SALVAR_DADOS_GERAIS_NOVA_COMPRA, this.dadosGerais)
            }
            this.atualizarSnapshot()
        },
        async validarTudo() {
            await this.validarDadosFormulario()
            this.validarDatas()
            this.validarPrazos()
            this.validarExistenciaAnexo()
            this.validarAnexos()
            this.validarCampoLocalEntrega()
            this.validarTelefone()
        },
        async tratarEventoAdicionarAnexo(anexo) {
            anexo.situacao = 'ATIVO'
            const dados = {
                compraDiretaId: this.compraDiretaId,
                anexo
            }
            await this.$store.dispatch(actionTypes.ADICIONAR_ANEXO_DADOS_GERAIS, dados)
        },
        async tratarEventoAtualizarTipoAnexo(anexo) {
            anexo.situacao = 'ATIVO'
            const anexoObjeto = {
                compraDiretaId: this.compraDiretaId,
                anexo: anexo
            }
            const data = await this.$store.dispatch(actionTypes.ATUALIZAR_TIPO_ANEXO_DADOS_GERAIS, anexoObjeto)
            anexo.situacao = data.situacao
        },
        async tratarEventoDeRemoverAnexo() {
            const objetoASerRemovido = {
                compraDiretaId: this.compraDiretaId,
                anexoId: this.anexoId
            }
            await this.$store.dispatch(actionTypes.REMOVER_ANEXO_DADOS_GERAIS, objetoASerRemovido)
            this.mostrarDialogoExclusao = false
            this.mostrarNotificacaoSucesso('Arquivo excluído com sucesso.')
        },
        async validarDadosFormulario() {
            const estaValidado = await this.$validator._base.validateAll()
            if (!estaValidado) {
                throw new Error('Preencha os campos obrigatórios.')
            }
        },
        validarCampoLocalEntrega() {
            if(this.dadosGerais.localEntrega.match(/^\d+$/)
                || this.dadosGerais.localEntrega.match(/^[/\s!@#$%^&*()_+-=[\]{};':"|,.<>/?]*$/g)) {
                throw new Error('O campo Local de Entrega deve conter letras e números.')
            }
        },
        async buscarOrgaosDisponiveis(){
            await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_ORGAOS_DISPONIVEIS, this.compraDiretaId)
            this.dadosGerais = this.$store.state.dadosGerais
        },
        validarTelefone(){
            if(!this.dadosGerais.telefoneContato.match(/(\(\d{2}\)\s)(\d{4,5}-\d{4})/)){
                throw new Error('O telefone inserido é inválido.')
            }
        },
        validarDatas() {
            const dataHoraAbertura = moment(this.dadosGerais.dataHoraAbertura)
            const dataHoraEncerramento = moment(this.dadosGerais.dataHoraEncerramento)
            const dataHoraInicioEnvioPropostas = moment(this.dadosGerais.dataHoraInicioEnvioPropostas)
            const dataHoraFimEnvioPropostas = moment(this.dadosGerais.dataHoraFimEnvioPropostas)
            const dataHoraAtual = moment(this.dataAtual())

            if (!dataHoraInicioEnvioPropostas) {
                if (!dataHoraInicioEnvioPropostas.isAfter(dataHoraAbertura)) {
                    throw new Error('A Data/Hora Inicio Envio de Propostas não pode ser anterior a Data/Hora de criação.')
                }
                if(!dataHoraInicioEnvioPropostas.isAfter(dataHoraAtual)){
                    throw new Error('A Data/Hora Inicio Envio de Propostas não pode ser anterior a Data/Hora atual.')
                }
            }
            if(this.exibirFimPropostasELances(this.dadosGerais.amparoLegal)){
                if (this.ehCompraPropostaManualEhAtiva) {
                    return
                }
                if (!dataHoraFimEnvioPropostas.isAfter(dataHoraAbertura)) {
                    throw new Error('A Data/Hora Fim Envio de Propostas não pode ser anterior a Data/Hora de criação.')
                }
                if(!dataHoraFimEnvioPropostas.isAfter(dataHoraAtual)){
                    throw new Error('A Data/Hora Fim Envio de Propostas não pode ser anterior a Data/Hora atual.')
                }
            }
            else{
                if (!dataHoraEncerramento.isAfter(dataHoraAbertura)) {
                    throw new Error('A Data/Hora de Encerramento não pode ser anterior a Data/Hora de criação.')
                }
                if(!dataHoraEncerramento.isAfter(dataHoraAtual)){
                    throw new Error('A Data/Hora de Encerramento não pode ser anterior a Data/Hora atual.')
                }
            }

        },
        validarPrazos() {
            const amparo = this.dadosGerais.amparoLegal

            if (amparo?.prazo != null) {
                const dataInicio = moment(this.dadosGerais.dataHoraInicioEnvioPropostas || this.dataAtual())
                const dataFim = moment(this.dadosGerais.dataHoraFimEnvioPropostas || this.dadosGerais.dataHoraEncerramento)
                const diasUteis = calcularDiasUteisComHoras(dataInicio, dataFim)

                if (amparo.prazoMinimoPublicacao && amparo.prazo) {
                    if (diasUteis < amparo.prazo) {
                        throw new Error(
                            `O intervalo mínimo entre o início e o término do envio de propostas, exigido por este amparo legal, deve ser de pelo menos ${amparo.prazo} dias úteis.`
                        )
                    }
                } else if (!amparo.prazoMinimoPublicacao && amparo.prazo) {
                    if (diasUteis < amparo.prazo) {
                        this.$store.commit(mutationTypes.LOKI.SHOW_ALERT, {
                            message: `O prazo informado está abaixo do recomendado para este amparo legal (${amparo.prazo} dias úteis).`,
                            type: 'warning'
                        })
                    }
                }
            }
        },
        dataAtual(){
            return new Date()
        },
        validarAnexos() {
            let estaValido = true
            this.dadosGerais.anexos.forEach(anexo => {
                if (anexo.documentoId === undefined || anexo.documentoId === null) {
                    estaValido = false
                }
            })
            if (!estaValido) {
                throw new Error('Informe o tipo do anexo.')
            }
        },
        validarExistenciaAnexo() {
            if (this.dadosGerais.anexos.length <= 0) {
                throw new Error('É necessário pelo menos um anexo para continuar.')
            }
        },
        tratarEventoExibirDialogoDeExclusao(id) {
            this.anexoId = id
            this.mostrarDialogoExclusao = true
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
        },
        tratarEventoVoltar() {
            this.redirecionarParaPaginaAnterior()
        },
        async tratarEventoAvancar() {
            const ehSuspensa = this.dadosGerais.situacao === 'SUSPENSA'
            const rotaDestino = ehSuspensa ? 'ItensLotesVisualizacao' : 'ItensLotesEdicao'
            await this.$router.push({name: rotaDestino, params: this.compraDiretaId})
        },
        redirecionarParaProximaPagina() {
            const ehSuspensa = this.dadosGerais.situacao === 'SUSPENSA'
            const rotaDestino = ehSuspensa ? 'ItensLotesVisualizacao' : 'ItensLotesEdicao'
            this.$router.push({name: rotaDestino, params: this.compraDiretaId})
        },
        redirecionarParaPaginaAnterior() {
            this.$router.push({name: this.$store.state.rota.origem})
        },
        normalizarDataHoraValor(valor) {
            if (!valor) return valor
            if (valor instanceof Date) {
                return moment(valor).format('YYYY-MM-DDTHH:mm:ss')
            }
            if (typeof valor === 'string') {
                const padrao = valor.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)
                if (padrao && padrao[0]) return padrao[0]
                const m = moment(valor)
                return m.isValid() ? m.format('YYYY-MM-DDTHH:mm:ss') : valor
            }
            return valor
        },
        normalizarCamposDataHora(dados) {
            if (!dados || typeof dados !== 'object') return
            const chaves = [
                'dataHoraAbertura',
                'dataHoraInicioEnvioPropostas',
                'dataHoraEncerramento',
                'dataHoraFimEnvioPropostas'
            ]
            chaves.forEach(campo => {
                if (Object.prototype.hasOwnProperty.call(dados, campo)) {
                    dados[campo] = this.normalizarDataHoraValor(dados[campo])
                }
            })
        },
        gerarSnapshot() {
            const dados = this.dadosGerais ? { ...this.dadosGerais } : {}
            if (dados) delete dados.anexos
            if (dados) delete dados.orgaos

            if (dados && dados.telefoneContato) {
                dados.telefoneContato = this.removerMascaraTelefone(dados.telefoneContato)
            }

            this.normalizarCamposDataHora(dados)
            return JSON.stringify(dados)
        },
        atualizarSnapshot() {
            this.originalDadosGeraisSnapshot = this.gerarSnapshot()
        },
        possuiDadosNaoSalvos() {
            if (!this.originalDadosGeraisSnapshot) return false
            return this.gerarSnapshot() !== this.originalDadosGeraisSnapshot
        },
        gerarObjetoNormalizadoAtual() {
            const dados = this.dadosGerais ? { ...this.dadosGerais } : {}
            if (dados) delete dados.anexos
            if (dados) delete dados.orgaos
            if (dados && dados.telefoneContato) {
                dados.telefoneContato = this.removerMascaraTelefone(dados.telefoneContato)
            }
            this.normalizarCamposDataHora(dados)
            return dados
        },
        obterSnapshotOriginalObjeto() {
            try {
                return this.originalDadosGeraisSnapshot ? JSON.parse(this.originalDadosGeraisSnapshot) : {}
            } catch (e) {
                return {}
            }
        },
        camposAlterados() {
            const atual = this.gerarObjetoNormalizadoAtual()
            const original = this.obterSnapshotOriginalObjeto()
            const chaves = Array.from(new Set([...Object.keys(original || {}), ...Object.keys(atual || {})]))
            return chaves.filter(chave => JSON.stringify(original[chave]) !== JSON.stringify(atual[chave]))
        },
        diferencasDetalhadas() {
            const atual = this.gerarObjetoNormalizadoAtual()
            const original = this.obterSnapshotOriginalObjeto()
            const chaves = this.camposAlterados()
            return chaves.map(chave => ({ campo: chave, anterior: original[chave], atual: atual[chave] }))
        },
        logAlteracoesNaoSalvas() {
            const anexosPendentes = this.possuiAnexosNaoSalvos()
            const campos = this.camposAlterados()
            const diffs = this.diferencasDetalhadas()
            const payload = {
                anexosPendentes,
                camposAlterados: campos,
                diferencas: diffs
            }
            try {
                if (typeof window !== 'undefined' && window['console'] && window['console'].info) {
                    window['console'].info('[DEBUG_LOG] DadosGeraisEdicao: alterações não salvas detectadas', payload)
                }
            } catch (e) { return payload }
        },
        possuiAnexosNaoSalvos() {
            return this.loki.uploadedFiles.length > 0
        },
        confirmarSaidaDaTela(next) {
            this.nextFunction = next
            this.mostrarDialogConfirmarSaida = true
        },
        sairDaTela(next) {
            this.$store.commit('SET_UPLOADED_FILES', [])
            this.mostrarDialogConfirmarSaida = false
            this.habilitarLoadingGlobal()
            next()
        },
        verificarRotaAvancar(rotaDestino) {
            return this.rotasAvancar.some(rota => {
                return rota.name === rotaDestino
            })
        },
        fecharModalAtualizarSituacaoAnexo() {
            this.anexoId = null
            this.situacaoAnexo = null
            this.titulo = ''
            this.mensagem = ''
            this.mostrarDialogoAtivoInativo = false
        },
        exibirModalAtualizarSituacaoAnexo(id, situacao) {
            this.anexoId = id
            this.situacaoAnexo = situacao
            if (this.situacaoAnexo === 'ATIVO') {
                this.titulo = 'Ativar Anexo'
                this.mensagem = 'Tem certeza que deseja ativar o anexo?'
            } else {
                this.titulo = 'Inativar Anexo'
                this.mensagem = 'Tem certeza que deseja inativar o anexo?'
            }
            this.mostrarDialogoAtivoInativo = true
        },
        async tratarEventDownloadAnexo(anexoInfo){
            const anexoDoc = anexoInfo.anexo
            if(anexoDoc.id && anexoDoc.uri)
                await this.$store.dispatch(actionTypes.DOWNLOAD_ANEXO, anexoDoc)
            else{
                const dados = {
                    compraDiretaId: this.compraDiretaId,
                    idVirtualizado: anexoDoc.idVirtualizado,
                    nomeArquivo: anexoDoc.nomeDocumento,
                    opcaoDownloadVirtualizacao: anexoInfo.tipoDownload,
                    noProcessoDigital: anexoDoc.noProcessoDigital
                }
                await this.$store.dispatch(actionTypes.BAIXAR_DOCUMENTO_VIRTUALIZADO, dados)
            }
        },
        async abrirModalSuspensao() {
            try {
                await this.buscarDadosGerais()
                this.mostrarModalSuspensao = true
            } catch (error) {
                this.mostrarNotificacaoErro('Erro ao buscar dados da compra direta.')
            }
        },
        fecharModalSuspensao() {
            this.mostrarModalSuspensao = false
        },
        async tratarEventoSuspender(objModal) {
            try {
                const objParaSuspender = {
                    compraDiretaId: this.compraDiretaId,
                    dados: {
                        justificativaSuspensao: objModal.motivo,
                    }
                }

                if (objModal.arquivo) {
                    objParaSuspender.dados.nomeArquivo = objModal.arquivo.nome

                    if (objModal.arquivo.uri) {
                        objParaSuspender.dados.uri = objModal.arquivo.uri
                    } else if (objModal.arquivo.file) {
                        objParaSuspender.dados.uri = await this.uploadArquivo(objModal.arquivo.file)
                    }
                }

                await this.$store.dispatch(actionTypes.SUSPENDER_COMPRA_DIRETA, objParaSuspender)
                this.mostrarNotificacaoSucesso('Compra direta suspensa com sucesso.')
                this.fecharModalSuspensao()

                await this.buscarDadosGerais()
            } catch (error) {
                this.mostrarNotificacaoErro(error.message || 'Erro ao suspender compra direta.')
            }
        },
        async uploadArquivo(arquivo) {
            if (!arquivo) return null
            
            const formData = new FormData()
            formData.append('file', arquivo)

            const { arquivo: uploadedFile } = await this.$store.dispatch(actionTypes.UPLOAD_ARQUIVO_SEM_LOKI, formData)

            return uploadedFile.uri
        },
    }
}
</script>

<style>
.required-field label:after {
    content: " *";
    color: rgb(255, 98, 98);
}

input::placeholder {
    color: #c2c2c2 !important;
}

textarea::placeholder {
    color: #c2c2c2 !important;
}
</style>
